import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker } from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 160,
  },
}));

export default function DagsetningTilFilter(props) {
  const classes = useStyles();
  const { label, filterName, setFilters } = props;
  const [selectedDate, setSelectedDate] = useState(null);

  const handleChange = (date) => {
    setSelectedDate(date);

    if (date !== null && date.isValid()) {
      setFilters(state => ({
        ...state,
        [filterName]: date.endOf('day').toISOString() // ISO 8601
      }));
    }
  }

  return (
    <div className={classes.formControl}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDatePicker
              variant="inline"
              autoOk={true}
              disableFuture={true}
              invalidDateMessage={'Dagsetning á röngu formi'}
              label={label}
              value={selectedDate}
              onChange={(date) => handleChange(date)}
              format="DD-MM-YYYY"
            />
      </MuiPickersUtilsProvider>
    </div>
  );
}